import {Platform, StyleSheet} from 'react-native';

import {black, cloudLight, onyx, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  headerWrapper: {
    zIndex: 10,
    elevation: 10,
  },
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    marginTop: 2,
    marginBottom: 6,
    height: 36,
    gap: 10,
    zIndex: 11,
  },
  overlay: {
    position: 'absolute' as any,
    top: 0,
    left: 0,
    width: '100vw' as any,
    height: '100vh' as any,
    zIndex: 5,
    backgroundColor: 'transparent',
  },
  dropdownButton: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 8,
    paddingHorizontal: 10,
    gap: 4,
    height: 36,
    backgroundColor: white,
    borderWidth: 1,
    borderColor: cloudLight,
    borderRadius: 8,
    shadowColor: black,
    shadowOffset: {width: 0, height: 1},
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
    zIndex: 11,
    ...(Platform.OS === 'web' && {cursor: 'pointer'}),
  },
  searchContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 12,
    height: 36,
    backgroundColor: white,
    borderWidth: 1,
    borderColor: cloudLight,
    borderRadius: 8,
    shadowColor: black,
    shadowOffset: {width: 0, height: 1},
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 2,
    gap: 4,
    ...(Platform.OS === 'web' && {cursor: 'text'}),
  },
  searchInput: {
    flex: 1,
    fontSize: 14,
    lineHeight: 18,
    color: black,
    padding: 0,
    margin: 0,
    outlineStyle: 'none' as any,
    ...(Platform.OS === 'web' && {cursor: 'text'}),
  } as any,
  icon: {
    fontSize: 18,
    color: onyx,
  },
  searchIcon: {
    fontSize: 18,
    color: onyx,
  },
  textPadding: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 2,
    flexShrink: 1,
  },
  text: {
    fontSize: 13,
    lineHeight: 18,
    color: black,
  },
  chevron: {
    fontSize: 18,
    color: onyx,
  },
  menu: {
    position: 'absolute' as any,
    top: 40,
    left: 16,
    backgroundColor: white,
    borderWidth: 1,
    borderColor: 'rgba(0, 0, 0, 0.08)',
    borderRadius: 8,
    shadowColor: 'rgba(10, 13, 18, 0.08)',
    shadowOffset: {width: 0, height: 12},
    shadowOpacity: 1,
    shadowRadius: 16,
    elevation: 10,
    paddingVertical: 4,
    zIndex: 12,
  },
  menuItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 6,
    paddingVertical: 2,
    minHeight: 38,
  },
  itemContent: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 6,
    paddingHorizontal: 10,
    gap: 12,
    borderRadius: 6,
  },
  radioRow: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  radioIcon: {
    marginLeft: 0,
    marginRight: 0,
  },
  radioLabel: {
    marginLeft: 10,
    lineHeight: 18,
    color: black,
    flexShrink: 1,
    fontSize: 13,
  },
  radioLabelSelected: {
    marginLeft: 10,
    lineHeight: 18,
    color: black,
    flexShrink: 1,
    fontSize: 13,
  },
});
